import type { Theme } from "@mui/material";

import { TaskPriority } from "src/types/dto/task.dto";

export const getThemeColor = (colorPath: string, theme: Theme) => {
    if (colorPath === 'transparent') return 'transparent';

    const pathParts = colorPath.split('.');
    let current: any = theme.palette;

    const found = pathParts.every((part) => {
      if (current && typeof current === 'object' && part in current) {
        current = current[part];
        return true;
      }
      return false;
    });

    return found && typeof current === 'string' ? current : colorPath;
};

export const getPriorityColor = (priority: TaskPriority | null) => {
  if (!priority) return 'grey.500';
  switch (priority) {
    case TaskPriority.LOW:
      return 'priority.low';
    case TaskPriority.NORMAL:
      return 'priority.normal';
    case TaskPriority.HIGH:
      return 'priority.high';
    case TaskPriority.URGENT:
      return 'priority.urgent';
    default:
      return 'grey.500';
  }
};